const appFor = (editor) => {
  return editor.view.dom.closest('[role="application"]');
};

const toolbarFor = (editor) => {
  const app = appFor(editor);
  return app?.querySelector('[role="toolbar"]');
};

const selectorFor = (command, value) => {
  if (value) {
    return `[data-command="${command}"][value="${value}"]`;
  }
  return `[data-command="${command}"]`;
};

const menuControlFor = (editor, command, value) => {
  const selector = selectorFor(command, value);
  return toolbarFor(editor)?.querySelector(selector);
};

const activeMenuControlFor = (editor, command, value) => {
  const selector = selectorFor(command, value);
  return toolbarFor(editor)?.querySelector(`${selector}.active`);
};

const menuStatusFor = (editor, command) => {
  return menuControlFor(editor, command)?.closest('[data-controller~="menu-status"]');
};

export { menuControlFor, activeMenuControlFor, menuStatusFor, toolbarFor, appFor };
